import React, { useState, useEffect, useContext } from 'react';
import {IProps, IState} from './types';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import ComboBox from '@components/ComboBox';
import { getDealerOrganizationsArray } from "@utils/DOIgnition/utils";

const SelectOrganization:React.FC<IProps> = (props) => {
    const [organization, setOrganization] = useState<string>('');
    const authContext = React.useContext(AuthContext);
    const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
    const{ setBrandDetail} = useContext(BrandsContext);

    return (
        <S.Root style={{
          display: props.open ? 'flex' : 'none',
        }} >
          <S.BoxContainer>
            <S.TitleContainer>
              <S.LeftSide>
                <S.Title>Create Brand</S.Title>
              </S.LeftSide>
            </S.TitleContainer>
            <S.Content>
            <S.Subtitle>
                Select an Organization if you would like this to be shared with other users. Otherwise this brand will only be visible to you.
            </S.Subtitle>
            <S.SetsTitle>Organization</S.SetsTitle>
            <S.ComboContainer>
            <ComboBox 
                id="organization"
                placeholder="Select"
                options={getDealerOrganizationsArray(userData["dealeron.dealerorganization"])??[]}
                required={false}
                disabled={false}
                position={"bottom"}
                chooseOption={(id:string, value:string) => setOrganization(value)}
                value={organization}
                containerStyle={{
                    padding: "0px",
                    width: "256px",
                }}
                optionContainerStyle={{top: '55px'}}
            />
            </S.ComboContainer>
            </S.Content>
            <S.ActionsContainer>
              <S.Action>
                <Button
                  label="CANCEL"
                  style={{
                    width: '112px',
                    marginRight: 12, 
                    backgroundColor: "transparent", 
                    border: `1px solid ${C.BLUE}`, 
                    hoverBackgroundColor: `${C.BLUE}22`,
                  }}
                  labelStyle={{color: C.BLUE}}
                  onClick={() => {props.setOpen(false)}}
                />
              </S.Action>
              <S.Action>
                <Button
                  label={"CREATE"}
                  style={{
                    width: '112px',
                    backgroundColor: C.BLUE, 
                    flexGrow: 0, 
                    hoverBackgroundColor: `${C.BLUE}AA`,
                  }} 
                  onClick={()=>{
                    setBrandDetail({open: true, organization: organization==='' ? 'DealerUser':organization});
                    props.setOpen(false);
                  }}
                />
              </S.Action>
            </S.ActionsContainer>
          </S.BoxContainer>
        </S.Root>
      );
}

export default SelectOrganization;